import { useAppContext } from "@/src/config/AppProvider";

const RightSide = () => {
  const { mobile, setMobile } = useAppContext();

  return (
    <div className="header-right">
      <div className="mobile-menu-bar d-block d-xl-none">
        <div className="hamberger">
          <button className="hamberger-button rbt-round-btn" onClick={() => setMobile(!mobile)}>
            <i className="feather-menu"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RightSide;
